<template>
  <v-dialog v-model="closeMailDialog" max-width="400" persistent>
    <v-card>
      <v-card-title>Close this Support</v-card-title>
      <v-card-text>
        Are you sure you want to permanently close support on this issue from {{
          this._decode(this.name).toUpperCase()
        }}?
      </v-card-text>
      <v-card-actions>
        <span class="error_message">{{ responseMessage }}</span>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="red" small text @click="closeDialog" v-on="on">
              NO
            </v-btn>
          </template>
          <span>cancel</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="blue" small text @click="submit" v-on="on">
              yes
            </v-btn>
          </template>
          <span>Submit</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//   import Restful from "@/services/RestFul";
//   import moment from "moment";
import Utils from "../../mixins/utils";

export default {
  props: {
    closeMailDialog: Boolean,
    myId: {type: String, default: null},
    name: {type: String, default: null}
  },
  mixins: [Utils],
  data() {
    return {
      responseMessage: null
    };
  },
  created() {
  },
  methods: {
    closeDialog() {
      let payload = {id: this.myId, state: false};
      this.$emit("closeRemove", payload);
    },
    submit() {
      let id = this._decode(this.myId);
      let active = false;
      let data = {id, active};
      let payload = {id: this.myId, data: data, state: false};
      this.$emit("submitClose", payload);
    }
  }
};
</script>
